<footer class="app-footer" role="contentinfo">
  <div class="app-footer__inner">
    <nav class="app-footer__nav" aria-label="Link piè di pagina">
      <a routerLink="/accessibilita" class="app-footer__link">
        Dichiarazione di accessibilità
      </a>
      @if (showPrivacyLink()) {
        <a routerLink="/informativa-privacy" class="app-footer__link">
          Informativa privacy
        </a>
      }
    </nav>
  </div>
</footer>
